/* Tazba kryptomien – v kosiku: tlacidlo "-" pri mnozstve 1 odstrani polozku */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('quantity-input button[name="minus"], .cart-quantity button[name="minus"]');
      if (!btn) return;
      var qi = btn.closest('quantity-input') || btn.parentElement;
      var input = qi && qi.querySelector('.quantity__input, input[name="updates[]"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      var min = parseInt(input.getAttribute('data-min') || input.getAttribute('min') || '1', 10) || 1;
      if (val > Math.max(min, 1)) return; // normal decrement

      // pri hodnote 1 -> odstranit polozku
      e.preventDefault();
      e.stopImmediatePropagation();
      var row =
        qi.closest('.cart-item') ||
        qi.closest('tr') ||
        qi.closest('.cart-items__table-row') ||
        (qi.parentElement && qi.parentElement.parentElement) ||
        document;
      var rm = row.querySelector('cart-remove-button a, cart-remove-button button, a.button--tertiary[href*="/cart/change"]');
      if (rm) rm.click();
    },
    true // capture: bezi skor ako Dawn handler (ktory ukazuje "minimalne mnozstvo je 1")
  );
})();
